import API from 'game_play/utils/api'
import {action, atom} from '@reatom/core'
import {shuffleArray} from "../Tabs/utils";
import {getBlandID} from "../utils";

/**
 * TABS
 * */
export const currentTabAtom = atom('')
export const tabsAtom = atom({})
export const messagesAtom = atom([])
export const changeTabAction = action((ctx, direction) => {
  const tab_key = ctx.get(currentTabAtom)
  const tabs = ctx.get(tabsAtom)
  const tab_keys = Object.keys(tabs)
  const target_key = tab_keys?.[tab_keys.indexOf(tab_key) + direction]
  if (target_key !== null) {
    currentTabAtom(ctx, target_key)
  }
})

/**
 * ACTIONS
 * */
export const saveCallbackBoxAtom = atom({
  callback: () => {
  }
})
export const saveAction = action(async (ctx, ...args) => {
  const callback = ctx.get(saveCallbackBoxAtom)?.callback
  if (callback) {
    callback(...args)
  }
})

export const cancelCallbackBoxAtom = atom({
  callback: () => {
  }
})
export const cancelAction = action(async (ctx, ...args) => {
  console.log('cancelAction', ctx.get(cancelCallbackBoxAtom))
  const callback = ctx.get(cancelCallbackBoxAtom)?.callback
  if (callback) {
    callback(...args)
  }
})
// это надо унести в модель Participant
export const participantsAtom = atom([], 'participantsAtom')
export const setParticipantsAction = action((ctx, next) => {
  // делим на seeded / остальные
  const seeded = next.filter(p => Number.isFinite(p.seed))
  const rest = next.filter(p => !Number.isFinite(p.seed))

  // сортируем seeded по seed ASC
  seeded.sort((a, b) => a.seed - b.seed)
  // итоговый список
  const arranged = [...seeded, ...rest]

  // проставляем order
  const participants = arranged.map((participant, i, arr) => ({
    ...participant, order: i,
  }))

  participantsAtom(ctx, participants)
}, 'setParticipantsAction')

export const shuffleParticipants = action((ctx) => {
  const participants = ctx.get(participantsAtom)
  const seeded = participants.filter(p => Number.isFinite(p.seed))
  const rest = participants.filter(p => !Number.isFinite(p.seed))

  const shuffledRest = shuffleArray(rest)

  // не трогаем seeded, тасуем только остальных.
  // setParticipantsAction сам отсортирует seeded по seed ASC
  // и пересчитает order для всего списка.
  setParticipantsAction(ctx, [...seeded, ...shuffledRest])
}, 'shuffleParticipants')

export const addBlankParticipant = action((ctx) => {
  const participants = ctx.get(participantsAtom)

  const blank = {
    id: getBlandID(),
    seed: null,
    order: null,   // пересчитается внутри setParticipantsAction
    group: null,
    player: {},
    player_1: {},
    player_2: {},
    player_3: {},
  }

  setParticipantsAction(ctx, [...participants, blank])
}, 'addBlankParticipant')

export const deleteParticipant = action((ctx, id) => {
  const participants = ctx.get(participantsAtom)

  const filtered = participants.filter(item => item.id !== id)

  setParticipantsAction(ctx, filtered)
}, 'deleteParticipant')

export const acceptRequest = action((ctx, source) => {
  const participants = ctx.get(participantsAtom)
  const requests = ctx.get(requestsAtom)

  const fromRequest = {
    ...source,
    id: getBlandID(),        // новый id для участника
    request_id: source.id,   // связь с заявкой
    seed: null,
    group: null,
    order: null,             // пересчитается внутри setParticipantsAction
  }

  // 1) добавляем участника (order выставится автоматически)
  setParticipantsAction(ctx, participants.concat(fromRequest))

  // 2) удаляем заявку (по player.id как у тебя)
  const nextRequests = requests.filter(
    (item) => item.player?.id !== source.player?.id
  )
  requestsAtom(ctx, nextRequests)
}, 'acceptRequest')

export class Tournament extends API {
  constructor(ctx, urls) {
    super(ctx, urls)
  }
}

/** MODEL DISTRIBUTED STORE */
export const modelStore = {}

export function getModel(model_name) {
  return modelStore?.[model_name]
}

export function getModelAtom(model_name) {
  return modelStore[model_name].atom
}

export function getModelSchema(model_name) {
  return modelStore[model_name].schema
}

/**
 * OTHER ATOMS
 */
export const requestsAtom = atom([])
export const requestSliceAtom = atom((ctx) => {
  const computed = ctx.spy(requestsAtom)
  return computed.slice(0, 5)
})
// export const requestsSortedAtom = atom((ctx) => {

// })
export const pageAtom = atom({})
export const tournamentIdAtom = atom(undefined)
export const leagueSlugAtom = atom(undefined)
export const seedAtom = atom((ctx) => {
  const computed = ctx.spy(participantsAtom)
  const result = [{
    value: null, label: '—',
  }]
  if (computed) {
    for (let i = 0; i < computed.length; i++) {
      result.push({
        value: i + 1, label: i + 1,
      })
    }
  }
  return result
})

export const groupAtom = atom((ctx) => {
  const computed = ctx.spy(getModelAtom('tournament.group_count'))
  const result = [{
    value: null, label: '—',
  }]
  if (computed) {
    for (let i = 0; i < computed; i++) {
      result.push({
        value: i + 1, label: i + 1,
      })
    }
  }
  // console.log('RECOMPUTED', computed, result)
  return result
})

export function getPlayerName(player){
  let name = `${player.first_name || ''} ${player.middle_name || ''} ${player.last_name || ''}`.trim()
  if (!name) {
    name = player.name
  }
  return name
}